(function () {
	function ready(fn) {
		if (document.readyState !== "loading") fn();
		else document.addEventListener("DOMContentLoaded", fn);
	}

	async function call(method, args, opts = {}) {
		const res = await fetch(`/api/method/${method}`, {
			method: opts.method || "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
				"X-Frappe-CSRF-Token": window.frappe?.csrf_token || "",
				"X-Requested-With": "XMLHttpRequest",
			},
			credentials: "same-origin",
			body: new URLSearchParams(args || {}),
		});
		if (!res.ok) {
			const err = await res.text();
			throw new Error(err || `HTTP ${res.status}`);
		}
		const data = await res.json();
		return data.message;
	}

	window.qcsPortal = { call };

	async function registerServiceWorker() {
		if (!("serviceWorker" in navigator)) return null;
		try {
			return await navigator.serviceWorker.register("/assets/qcs_team_sync/pwa/sw.js", {
				scope: "/",
			});
		} catch (e) {
			console.warn("[QCS] SW registration failed:", e);
			return null;
		}
	}

	async function subscribePush(reg) {
		if (!reg || !("PushManager" in window)) return;
		try {
			const pk = await call("qcs_team_sync.api.push.get_public_key", {}, { method: "POST" });
			if (!pk || !pk.public_key) return;

			const existing = await reg.pushManager.getSubscription();
			const sub =
				existing ||
				(await reg.pushManager.subscribe({
					userVisibleOnly: true,
					applicationServerKey: urlBase64ToUint8Array(pk.public_key),
				}));

			const keys = sub.toJSON().keys || {};
			await call("qcs_team_sync.api.push.subscribe", {
				endpoint: sub.endpoint,
				p256dh: keys.p256dh || "",
				auth: keys.auth || "",
				user_agent: navigator.userAgent,
			});
		} catch (e) {
			/* Permission denied / unsupported — silently ignore */
		}
	}

	function wireInstallButton() {
		let deferred = null;

		window.addEventListener("beforeinstallprompt", (e) => {
			e.preventDefault();
			deferred = e;
			showInstallButton();
		});

		window.addEventListener("appinstalled", () => {
			hideInstallButton();
			deferred = null;
		});

		function showInstallButton() {
			if (document.getElementById("qcs-install-btn")) return;
			const btn = document.createElement("button");
			btn.id = "qcs-install-btn";
			btn.type = "button";
			btn.textContent = "📲 Install QCS";
			Object.assign(btn.style, {
				position: "fixed",
				bottom: "16px",
				right: "16px",
				zIndex: "9999",
				padding: "12px 18px",
				borderRadius: "999px",
				border: "none",
				background: "#1677ff",
				color: "#fff",
				fontSize: "14px",
				fontWeight: "600",
				boxShadow: "0 8px 24px rgba(22,119,255,0.35)",
				cursor: "pointer",
			});
			btn.addEventListener("click", async () => {
				if (!deferred) return;
				deferred.prompt();
				const { outcome } = await deferred.userChoice;
				deferred = null;
				if (outcome === "accepted") hideInstallButton();
			});
			document.body.appendChild(btn);
		}

		function hideInstallButton() {
			const b = document.getElementById("qcs-install-btn");
			if (b) b.remove();
		}
	}

	async function setupPWA() {
		const reg = await registerServiceWorker();
		wireInstallButton();
		subscribePush(reg);
	}

	// --------- Running-timer banner (shared across /m/* + /team-today) ---------

	function wireTimerBanner() {
		// Skip on the login page
		if (document.body.getAttribute("frappe-session-status") !== "logged-in") return;

		const banner = document.createElement("div");
		banner.id = "qcs-timer-banner";
		banner.style.cssText = [
			"position:fixed", "left:0", "right:0", "bottom:0",
			"background:linear-gradient(90deg,#1677ff,#4f46e5)",
			"color:#fff", "font-weight:600", "font-size:14px",
			"padding:10px 14px", "display:none", "align-items:center",
			"justify-content:space-between", "gap:10px", "z-index:9998",
			"box-shadow:0 -8px 24px rgba(0,0,0,0.12)",
		].join(";");
		document.body.appendChild(banner);

		let current = null;
		let tickInterval = null;
		let pollTimeout = null;

		function formatElapsed(fromTime) {
			const start = new Date(fromTime.replace(" ", "T")).getTime();
			const secs = Math.max(0, Math.floor((Date.now() - start) / 1000));
			const h = Math.floor(secs / 3600);
			const m = Math.floor((secs % 3600) / 60);
			const s = secs % 60;
			return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
		}

		function render() {
			if (!current) {
				banner.style.display = "none";
				clearInterval(tickInterval);
				tickInterval = null;
				return;
			}
			banner.style.display = "flex";
			banner.innerHTML = `
				<div style="min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
					⏱ <b style="margin-right:4px">${formatElapsed(current.from_time)}</b>
					<span style="opacity:0.85">${escapeHtml(current.task_title || current.task)}</span>
				</div>
				<button class="qcs-stop-timer" style="
					background:rgba(255,255,255,0.22);border:none;color:#fff;
					padding:6px 14px;border-radius:999px;font-weight:700;cursor:pointer
				">Stop</button>
			`;
			if (!tickInterval) {
				tickInterval = setInterval(() => {
					const label = banner.querySelector("b");
					if (label && current) label.textContent = formatElapsed(current.from_time);
				}, 1000);
			}
		}

		async function poll() {
			try {
				const r = await call("qcs_team_sync.api.timer.current", {}, { method: "POST" });
				current = r || null;
			} catch (e) {
				current = null;
			}
			render();
			pollTimeout = setTimeout(poll, 10000);
		}

		banner.addEventListener("click", async (ev) => {
			if (!ev.target.classList.contains("qcs-stop-timer")) return;
			try {
				await call("qcs_team_sync.api.timer.stop");
				current = null;
				render();
				document.dispatchEvent(new CustomEvent("qcs:timer:changed", { detail: null }));
			} catch (err) {
				alert((err && err.message) || "Could not stop timer");
			}
		});

		document.addEventListener("qcs:timer:changed", (ev) => {
			current = ev.detail;
			render();
		});

		poll();

		// Pad the body so content isn't hidden behind the banner.
		const pad = document.createElement("style");
		pad.textContent = "body.qcs-has-timer { padding-bottom: 56px !important; }";
		document.head.appendChild(pad);

		const applyPad = () => {
			document.body.classList.toggle("qcs-has-timer", !!current);
		};
		document.addEventListener("qcs:timer:changed", applyPad);
		const orig = render;
		// Swap render to also toggle the padding class
		const wrapped = function () {
			orig.apply(null, arguments);
			applyPad();
		};
		// Re-bind by monkey-patching:
		// eslint-disable-next-line no-func-assign
		render = wrapped;  // noqa
	}

	function escapeHtml(s) {
		if (s === null || s === undefined) return "";
		return String(s)
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#39;");
	}

	async function toggleTaskTimer(task) {
		const running = await call("qcs_team_sync.api.timer.current", {}, { method: "POST" });
		if (running && running.task === task) {
			await call("qcs_team_sync.api.timer.stop");
			document.dispatchEvent(new CustomEvent("qcs:timer:changed", { detail: null }));
			return { started: false };
		}
		const r = await call("qcs_team_sync.api.timer.start", { task });
		// Fetch fresh current so we have task_title
		const cur = await call("qcs_team_sync.api.timer.current", {}, { method: "POST" });
		document.dispatchEvent(new CustomEvent("qcs:timer:changed", { detail: cur }));
		return { started: true, ...(r || {}) };
	}

	window.qcsPortal.toggleTaskTimer = toggleTaskTimer;

	// ---------- Pull-to-refresh ----------

	function wirePullToRefresh() {
		const root = document.querySelector("[data-qcs-pull-refresh]");
		if (!root) return;

		let startY = null;
		let pulling = false;
		let indicator = null;

		function ensureIndicator() {
			if (indicator) return indicator;
			indicator = document.createElement("div");
			indicator.className = "qcs-ptr-indicator";
			indicator.innerHTML = `<div class="qcs-ptr-spinner"></div><div class="qcs-ptr-label">Pull to refresh</div>`;
			Object.assign(indicator.style, {
				position: "fixed", left: "0", right: "0", top: "0",
				display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
				background: "#1677ff", color: "#fff", fontSize: "13px", fontWeight: "600",
				padding: "10px", transform: "translateY(-100%)",
				transition: "transform 0.15s", zIndex: "9995",
			});
			document.body.appendChild(indicator);
			return indicator;
		}

		root.addEventListener("touchstart", (e) => {
			if (window.scrollY > 0) return;
			startY = e.touches[0].clientY;
			pulling = false;
		}, { passive: true });

		root.addEventListener("touchmove", (e) => {
			if (startY === null) return;
			const dy = e.touches[0].clientY - startY;
			if (dy <= 0) return;
			if (window.scrollY > 0) { startY = null; return; }
			pulling = true;
			const ind = ensureIndicator();
			const pulled = Math.min(dy, 120);
			ind.style.transform = `translateY(${Math.min(pulled - 60, 0)}px)`;
			ind.querySelector(".qcs-ptr-label").textContent = pulled > 80 ? "Release to refresh" : "Pull to refresh";
		}, { passive: true });

		root.addEventListener("touchend", (e) => {
			if (!pulling) { startY = null; return; }
			const dy = (e.changedTouches && e.changedTouches[0].clientY - startY) || 0;
			startY = null;
			pulling = false;
			const ind = ensureIndicator();
			if (dy > 80) {
				ind.style.transform = "translateY(0)";
				ind.querySelector(".qcs-ptr-label").textContent = "Refreshing…";
				setTimeout(() => { window.location.reload(); }, 400);
			} else {
				ind.style.transform = "translateY(-100%)";
			}
		});

		// Inject spinner styles
		const s = document.createElement("style");
		s.textContent = `
			.qcs-ptr-spinner {
				width: 14px; height: 14px;
				border: 2px solid rgba(255,255,255,0.4);
				border-top-color: #fff;
				border-radius: 50%;
				animation: qcs-ptr-spin 0.8s linear infinite;
			}
			@keyframes qcs-ptr-spin { to { transform: rotate(360deg); } }
		`;
		document.head.appendChild(s);
	}

	// ---------- Swipe gestures on task cards ----------

	function wireSwipeActions() {
		const SWIPE_THRESHOLD = 80;
		const HINT_THRESHOLD = 30;

		document.querySelectorAll(".qcs-task-card[data-swipe]").forEach((card) => {
			const main = card.querySelector(".qcs-task-card-main");
			const actions = card.querySelector(".qcs-task-card-actions");
			if (!main) return;

			let startX = null, startY = null, dx = 0, swiping = false, locked = false;

			card.addEventListener("touchstart", (e) => {
				if (e.target.closest("button, select")) return;
				startX = e.touches[0].clientX;
				startY = e.touches[0].clientY;
				dx = 0;
				swiping = false;
				locked = false;
			}, { passive: true });

			card.addEventListener("touchmove", (e) => {
				if (startX === null) return;
				const cx = e.touches[0].clientX;
				const cy = e.touches[0].clientY;
				const ddx = cx - startX;
				const ddy = cy - startY;

				if (!locked) {
					if (Math.abs(ddy) > Math.abs(ddx) + 4) {
						// vertical scroll — bail out, let the page scroll
						startX = null; return;
					}
					if (Math.abs(ddx) > 6) {
						locked = true;
						swiping = true;
						card.classList.add("is-swiping");
					}
				}
				if (!swiping) return;

				dx = ddx;
				main.style.transform = `translateX(${dx}px)`;
				if (actions) actions.style.transform = `translateX(${dx}px)`;

				card.classList.toggle("show-swipe-left", dx > HINT_THRESHOLD);
				card.classList.toggle("show-swipe-right", dx < -HINT_THRESHOLD);
			}, { passive: true });

			card.addEventListener("touchend", async () => {
				if (!swiping) { startX = null; return; }
				swiping = false;
				card.classList.remove("is-swiping");

				const commit = Math.abs(dx) > SWIPE_THRESHOLD ? Math.sign(dx) : 0;
				const task = card.dataset.task;

				if (commit === 0) {
					main.style.transform = "";
					if (actions) actions.style.transform = "";
					card.classList.remove("show-swipe-left", "show-swipe-right");
					return;
				}

				// Snap to fully-swiped position
				const w = card.offsetWidth;
				main.style.transform = `translateX(${commit * w}px)`;
				if (actions) actions.style.transform = `translateX(${commit * w}px)`;
				main.style.transition = actions.style.transition = "transform 0.2s";

				try {
					if (commit > 0) {
						// Right → mark done
						await call("qcs_team_sync.api.mobile.update_task", { name: task, status: "Done" });
						toast("Marked Done", "green");
						setTimeout(() => card.remove(), 220);
					} else {
						// Left → reschedule due +1 day
						const today = new Date();
						const due = new Date(today.getTime() + 24 * 60 * 60 * 1000);
						const iso = due.toISOString().slice(0, 10);
						await call("qcs_team_sync.api.mobile.update_task", { name: task, due_date: iso });
						toast("Rescheduled to tomorrow", "blue");
						// Snap back after success
						setTimeout(() => {
							main.style.transform = "";
							if (actions) actions.style.transform = "";
							main.style.transition = actions.style.transition = "";
							card.classList.remove("show-swipe-left", "show-swipe-right");
						}, 300);
					}
				} catch (err) {
					toast((err && err.message) || "Action failed", "red");
					main.style.transform = "";
					if (actions) actions.style.transform = "";
					main.style.transition = actions.style.transition = "";
					card.classList.remove("show-swipe-left", "show-swipe-right");
				}
				startX = null; dx = 0;
			});
		});
	}

	// ---------- Task detail: comments, activity, reassign ----------

	function wireTaskDetailExtras() {
		const head = document.querySelector(".qcs-task-head[data-task]");
		if (!head) return;
		const task = head.dataset.task;

		loadComments(task);
		loadActivity(task);
		wireReassignButton(task);
		wireCommentPost(task);
	}

	function escapeHtml(s) {
		if (s === null || s === undefined) return "";
		return String(s)
			.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;").replace(/'/g, "&#39;");
	}

	function initials(name) {
		return String(name || "?").trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();
	}

	function timeAgo(iso) {
		const then = new Date(iso.replace(" ", "T")).getTime();
		const diff = Math.max(0, Math.floor((Date.now() - then) / 1000));
		if (diff < 60) return "just now";
		if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
		if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
		if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
		return new Date(iso).toLocaleDateString();
	}

	async function loadComments(task) {
		const wrap = document.querySelector("[data-qcs-comments]");
		if (!wrap) return;
		try {
			const rows = await call("qcs_team_sync.api.mobile.task_comments", { task }, { method: "POST" });
			renderComments(wrap, rows || []);
		} catch (e) {
			wrap.innerHTML = `<div class="qcs-muted">Could not load comments.</div>`;
		}
	}

	function renderComments(wrap, rows) {
		if (!rows.length) {
			wrap.innerHTML = `<div class="qcs-muted">No comments yet. Start the conversation.</div>`;
			return;
		}
		wrap.innerHTML = rows.map((c) => commentHtml(c)).join("");
	}

	function commentHtml(c) {
		const avatar = c.author_image
			? `<span class="qcs-avatar"><img src="${escapeHtml(c.author_image)}" alt=""/></span>`
			: `<span class="qcs-avatar">${initials(c.author_name)}</span>`;
		return `
			<div class="qcs-comment">
				${avatar}
				<div class="qcs-comment-body">
					<div class="qcs-comment-meta">
						<span class="qcs-comment-author">${escapeHtml(c.author_name)}</span>
						<span class="qcs-comment-time">${timeAgo(c.creation_iso)}</span>
					</div>
					<div class="qcs-comment-content">${c.content}</div>
				</div>
			</div>
		`;
	}

	function wireCommentPost(task) {
		const form = document.querySelector("[data-qcs-comment-form]");
		if (!form) return;
		form.addEventListener("submit", async (ev) => {
			ev.preventDefault();
			const ta = form.querySelector("textarea");
			const btn = form.querySelector("button[type=submit]");
			const content = (ta.value || "").trim();
			if (!content) return;
			btn.disabled = true;
			try {
				await call("qcs_team_sync.api.mobile.post_comment", { task, content });
				ta.value = "";
				loadComments(task);
				loadActivity(task);
				toast("Comment posted", "blue");
			} catch (e) {
				toast((e && e.message) || "Could not post", "red");
			} finally {
				btn.disabled = false;
			}
		});
	}

	async function loadActivity(task) {
		const wrap = document.querySelector("[data-qcs-activity]");
		if (!wrap) return;
		try {
			const rows = await call("qcs_team_sync.api.mobile.task_activity", { task }, { method: "POST" });
			renderActivity(wrap, rows || []);
		} catch (e) {
			wrap.innerHTML = `<div class="qcs-muted">Could not load activity.</div>`;
		}
	}

	function renderActivity(wrap, rows) {
		if (!rows.length) {
			wrap.innerHTML = `<div class="qcs-muted">No activity yet.</div>`;
			return;
		}
		wrap.innerHTML = rows.map((a) => {
			const when = timeAgo(a.when);
			const who = escapeHtml(a.actor_name || a.actor);
			if (a.kind === "change") {
				return `
					<div class="qcs-activity-item">
						<span class="qcs-activity-dot change"></span>
						<div>
							<span class="qcs-activity-who">${who}</span>
							changed <b>${escapeHtml(a.field)}</b>
							${a.old_value ? `from <code>${escapeHtml(a.old_value)}</code>` : ""}
							to <code>${escapeHtml(a.new_value)}</code>
							<span class="qcs-activity-when"> · ${when}</span>
						</div>
					</div>
				`;
			}
			const dotCls = a.kind === "mention" ? "mention" : "comment";
			return `
				<div class="qcs-activity-item">
					<span class="qcs-activity-dot ${dotCls}"></span>
					<div>
						<span class="qcs-activity-who">${who}</span> ${a.kind === "mention" ? "mentioned you" : "commented"}
						<div class="qcs-comment-content" style="margin-top:2px">${a.content || ""}</div>
						<span class="qcs-activity-when">${when}</span>
					</div>
				</div>
			`;
		}).join("");
	}

	function wireReassignButton(task) {
		const btn = document.querySelector("[data-qcs-reassign]");
		if (!btn) return;
		btn.addEventListener("click", async (ev) => {
			ev.preventDefault();
			btn.disabled = true;
			try {
				const [members, taskDoc] = await Promise.all([
					call("qcs_team_sync.api.mobile.team_members", { task }, { method: "POST" }),
					call("qcs_team_sync.api.mobile.get_task", { name: task }, { method: "POST" }),
				]);
				openReassignSheet(task, members || [], taskDoc && taskDoc.assigned_to);
			} catch (e) {
				toast((e && e.message) || "Could not load team", "red");
			} finally {
				btn.disabled = false;
			}
		});
	}

	function openReassignSheet(task, members, current) {
		const overlay = document.createElement("div");
		overlay.style.cssText = [
			"position:fixed", "inset:0", "background:rgba(0,0,0,0.5)",
			"z-index:10001", "display:flex", "align-items:flex-end",
			"justify-content:center",
		].join(";");
		const sheet = document.createElement("div");
		sheet.style.cssText = [
			"background:#fff", "width:100%", "max-width:600px",
			"border-top-left-radius:16px", "border-top-right-radius:16px",
			"padding:18px", "max-height:80vh", "overflow:hidden",
			"display:flex", "flex-direction:column",
		].join(";");
		sheet.innerHTML = `
			<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px">
				<h3 style="margin:0;font-size:17px">Reassign task</h3>
				<button type="button" class="qcs-sheet-close"
					style="background:transparent;border:none;font-size:20px;cursor:pointer;color:#6b7280">×</button>
			</div>
			<div class="qcs-reassign-picker">
				${members.map((m) => `
					<div class="qcs-reassign-row ${m.name === current ? "current" : ""}" data-user="${escapeHtml(m.name)}">
						<span class="qcs-avatar">${m.user_image ? `<img src="${escapeHtml(m.user_image)}" alt=""/>` : initials(m.full_name)}</span>
						<span class="qcs-reassign-name">${escapeHtml(m.full_name || m.name)}</span>
						${m.name === current ? `<span class="qcs-reassign-badge">Current</span>` : ""}
					</div>
				`).join("")}
			</div>
		`;
		overlay.appendChild(sheet);
		document.body.appendChild(overlay);

		overlay.addEventListener("click", (ev) => {
			if (ev.target === overlay || ev.target.classList.contains("qcs-sheet-close")) {
				overlay.remove();
			}
		});

		sheet.querySelectorAll(".qcs-reassign-row").forEach((row) => {
			row.addEventListener("click", async () => {
				const new_user = row.dataset.user;
				if (new_user === current) { overlay.remove(); return; }
				row.style.opacity = "0.5";
				try {
					await call("qcs_team_sync.api.mobile.update_task", {
						name: task,
						assigned_to: new_user,
					});
					toast("Reassigned", "green");
					overlay.remove();
					setTimeout(() => window.location.reload(), 400);
				} catch (e) {
					toast((e && e.message) || "Reassign failed", "red");
					row.style.opacity = "1";
				}
			});
		});
	}

	window.qcsPortal.loadComments = loadComments;
	window.qcsPortal.loadActivity = loadActivity;

	window.qcsSetupPWA = setupPWA;

	function urlBase64ToUint8Array(base64) {
		const padding = "=".repeat((4 - (base64.length % 4)) % 4);
		const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
		const raw = atob(b64);
		const out = new Uint8Array(raw.length);
		for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
		return out;
	}

	window.qcsPortal.setupPWA = setupPWA;

	ready(() => {
		// Register SW + wire install button on every portal page so any entry
		// point (mobile hub, check-in, tasks, leave, team-today) counts toward
		// Chrome's "installability engagement" heuristic.
		setupPWA();

		// Floating running-timer banner (visible on every portal page while a
		// timer is active). Polls every 10s; ticks elapsed every 1s.
		wireTimerBanner();

		// Per-row start/stop buttons anywhere in the DOM.
		const playIcon = `<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>`;
		const stopIcon = `<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="6" width="12" height="12" rx="2"/></svg>`;

		function fmtHMS(startMs) {
			const secs = Math.max(0, Math.floor((Date.now() - startMs) / 1000));
			const h = Math.floor(secs / 3600);
			const m = Math.floor((secs % 3600) / 60);
			const s = secs % 60;
			return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
		}

		document.addEventListener("click", async (ev) => {
			const btn = ev.target.closest("[data-qcs-timer-task]");
			if (!btn) return;
			ev.preventDefault();
			ev.stopPropagation();
			const task = btn.dataset.qcsTimerTask;
			const wasRunning = btn.classList.contains("running");
			btn.disabled = true;

			try {
				if (wasRunning) {
					// Stopping — call API, then update UI.
					await call("qcs_team_sync.api.timer.stop");
					document.dispatchEvent(new CustomEvent("qcs:timer:changed", { detail: null }));
					btn.classList.remove("running");
					btn.innerHTML = `${playIcon}<span>Start</span>`;
					if (btn._tick) { clearInterval(btn._tick); btn._tick = null; }
					// Remove the "is-running" highlight + running card.
					const card = btn.closest(".qcs-task-card");
					if (card) card.classList.remove("is-running");
					const runningCard = document.querySelector(".qcs-running-card");
					if (runningCard) runningCard.remove();
					toast("Stopped", "green");
				} else {
					// Starting — start local ticker immediately for instant feedback.
					const startMs = Date.now();
					btn.classList.add("running");
					btn.innerHTML = `${stopIcon}<span>${fmtHMS(startMs)}</span>`;
					if (btn._tick) clearInterval(btn._tick);
					btn._tick = setInterval(() => {
						const span = btn.querySelector("span");
						if (span) span.textContent = fmtHMS(startMs);
					}, 1000);
					// Highlight the card
					const card = btn.closest(".qcs-task-card");
					if (card) card.classList.add("is-running");

					try {
						await call("qcs_team_sync.api.timer.start", { task });
					} catch (e) {
						// Rollback on failure.
						clearInterval(btn._tick); btn._tick = null;
						btn.classList.remove("running");
						btn.innerHTML = `${playIcon}<span>Start</span>`;
						if (card) card.classList.remove("is-running");
						throw e;
					}
					// Fetch fresh task_title + from_time for the banner/card.
					const cur = await call("qcs_team_sync.api.timer.current", {}, { method: "POST" });
					document.dispatchEvent(new CustomEvent("qcs:timer:changed", { detail: cur }));
					toast("Timer started", "blue");
				}
			} catch (err) {
				toast((err && err.message) || "Timer error", "red");
			} finally {
				btn.disabled = false;
			}
		});

		// Live-tick the "Running" card at the top of /m/tasks (if rendered server-side).
		const runningCard = document.querySelector(".qcs-running-card[data-from]");
		if (runningCard) {
			const from = runningCard.getAttribute("data-from");
			const startMs = from ? new Date(from.replace(" ", "T")).getTime() : Date.now();
			const el = runningCard.querySelector("[data-elapsed]");
			const tick = () => { if (el) el.textContent = fmtHMS(startMs); };
			tick();
			setInterval(tick, 1000);
		}

		wirePullToRefresh();
		wireSwipeActions();
		wireTaskDetailExtras();

		// Live-tick any task card that was rendered as is-running on initial load.
		document.querySelectorAll(".qcs-task-card.is-running .qcs-timer-btn.running").forEach((btn) => {
			const from = runningCard && runningCard.getAttribute("data-from");
			const startMs = from ? new Date(from.replace(" ", "T")).getTime() : Date.now();
			btn.innerHTML = `${stopIcon}<span>${fmtHMS(startMs)}</span>`;
			btn._tick = setInterval(() => {
				const span = btn.querySelector("span");
				if (span) span.textContent = fmtHMS(startMs);
			}, 1000);
		});

		function toast(message, color) {
			const t = document.createElement("div");
			t.textContent = message;
			t.style.cssText = [
				"position:fixed", "bottom:76px", "left:50%",
				"transform:translateX(-50%)", "z-index:10000",
				"background:#111827", "color:#fff",
				"padding:10px 18px", "border-radius:999px",
				"font-size:13px", "font-weight:600",
				"box-shadow:0 8px 24px rgba(0,0,0,0.2)",
				"opacity:0", "transition:opacity 0.2s",
			].join(";");
			if (color === "red") t.style.background = "#b91c1c";
			if (color === "green") t.style.background = "#047857";
			if (color === "blue") t.style.background = "#1e40af";
			document.body.appendChild(t);
			requestAnimationFrame(() => { t.style.opacity = "1"; });
			setTimeout(() => {
				t.style.opacity = "0";
				setTimeout(() => t.remove(), 250);
			}, 2000);
		}
		window.qcsPortal.toast = toast;

		document.querySelectorAll("[data-qcs-form]").forEach((form) => {
			form.addEventListener("submit", async (ev) => {
				ev.preventDefault();
				const method = form.dataset.qcsForm;
				const btn = form.querySelector("button[type=submit]");
				const alertBox = form.querySelector(".qcs-alert");
				if (alertBox) alertBox.remove();
				if (btn) btn.disabled = true;
				try {
					const payload = Object.fromEntries(new FormData(form).entries());
					const result = await call(method, payload);
					const next = form.dataset.qcsRedirect;
					if (next) {
						window.location = next;
					} else {
						form.insertAdjacentHTML(
							"afterbegin",
							`<div class="qcs-alert">Saved ✓</div>`
						);
						if (result && form.dataset.qcsReset === "1") form.reset();
					}
				} catch (err) {
					form.insertAdjacentHTML(
						"afterbegin",
						`<div class="qcs-alert error">${(err && err.message) || "Error"}</div>`
					);
				} finally {
					if (btn) btn.disabled = false;
				}
			});
		});

		// Task detail form (partial update) on /m/task
		document.querySelectorAll(".qcs-task-update").forEach((form) => {
			form.addEventListener("submit", async (ev) => {
				ev.preventDefault();
				const task = form.dataset.task;
				const payload = Object.fromEntries(new FormData(form).entries());
				payload.name = task;
				const btn = form.querySelector("button[type=submit]");
				if (btn) btn.disabled = true;
				try {
					await call("qcs_team_sync.api.mobile.update_task", payload);
					form.insertAdjacentHTML("afterbegin", `<div class="qcs-alert">Saved ✓</div>`);
					setTimeout(() => form.querySelector(".qcs-alert")?.remove(), 1500);
				} catch (err) {
					form.insertAdjacentHTML(
						"afterbegin",
						`<div class="qcs-alert error">${(err && err.message) || "Save failed"}</div>`
					);
				} finally {
					if (btn) btn.disabled = false;
				}
			});
		});

		// Subtask checkbox toggle
		document.querySelectorAll(".qcs-subtask-toggle").forEach((cb) => {
			cb.addEventListener("change", async (ev) => {
				const task = ev.target.dataset.task;
				const subtask = ev.target.dataset.subtask;
				const is_done = ev.target.checked ? 1 : 0;
				try {
					await call("qcs_team_sync.api.mobile.toggle_subtask", { task, subtask, is_done });
				} catch (err) {
					ev.target.checked = !ev.target.checked;
					alert((err && err.message) || "Could not update subtask");
				}
			});
		});

		document.querySelectorAll(".qcs-task-status").forEach((sel) => {
			sel.addEventListener("change", async (ev) => {
				const task = ev.target.dataset.task;
				const status = ev.target.value;
				const row = ev.target.closest(".qcs-task-row");
				try {
					await call("qcs_team_sync.api.mobile.set_task_status", { task, status });
					if (row) row.classList.toggle("done", status === "Done");
				} catch (err) {
					alert((err && err.message) || "Could not update task");
				}
			});
		});
	});
})();
